import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

import { StyledLink, StyledAnchor, ArrowCircle } from "./style";

type ArrowLinkProps = {
  to: string;
  isInternalDestination: boolean;
  text?: string;
  ariaLabel?: string;
  onClick?: () => void;
};

const ArrowLink: React.FC<ArrowLinkProps> = ({
  to,
  isInternalDestination,
  text,
  ariaLabel,
  onClick,
}: ArrowLinkProps) => {
  if (isInternalDestination) {
    return (
      <StyledLink
        to={to}
        data-test-id="arrow-link"
        aria-label={ariaLabel}
        onClick={onClick}
      >
        <ArrowCircle>
          <FontAwesomeIcon icon={faArrowRight} />
        </ArrowCircle>
        {text}
      </StyledLink>
    );
  }

  return (
    <StyledAnchor
      href={to}
      target="_blank"
      rel="noopener noreferrer"
      data-test-id="arrow-link"
      aria-label={ariaLabel}
      onClick={onClick}
    >
      <ArrowCircle>
        <FontAwesomeIcon icon={faArrowRight} />
      </ArrowCircle>
      {text}
    </StyledAnchor>
  );
};

export default ArrowLink;
